import Panel from '../../components/Panel';
import Badge from '../../components/Badge';
import RolesMatrix from './roles/RolesMatrix';

/**
 * 权限配置标签页（P4.4 真实实现）。
 *
 * 权限：role:manage；数据源：GET /api/system/roles、GET /api/system/permissions。
 * 角色权限矩阵见 ./roles/RolesMatrix。
 */
export default function RolesPanel() {
  return (
    <Panel title="权限配置" extra={<Badge tone="brand">角色权限矩阵</Badge>}>
      <RolesMatrix />
    </Panel>
  );
}
